export default __webpack_public_path__ + "static/media/7.a3ea8713.jpg";